export default __webpack_public_path__ + "static/media/help.69f96a33.svg";